module Client.ExamplePasswordGenerator

open System
open Shared.Zxcvbn

let private RECOMMENDATION_LENGTH = 14
let private LOWER = [| 'a';'b';'c';'d';'e';'f';'g'; 'h'; 'i'; 'j'; 'k'; 'l'; 'm'; 'n'; 'o'; 'p'; 'q'; 'r'; 's'; 't'; 'u'; 'v'; 'w'; 'x'; 'x'; 'z' |]
let private UPPER = [| 'A';'B';'C';'D';'E';'F';'G'; 'H'; 'I'; 'J'; 'K'; 'L'; 'M'; 'N'; 'O'; 'P'; 'Q'; 'R'; 'S'; 'T'; 'U'; 'V'; 'W'; 'X'; 'Y'; 'Z' |]
let private NUMBERS = [| '1'; '2'; '3'; '4'; '5'; '6'; '7'; '8'; '9'; '0' |]
let private SPECIAL = [| '@'; '!'; '£'; '$'; '%'; '&' |]
let private EMPTY_SLOT = '\u0000'

let private rndGen = new Random()

let private calcLength minValue maxValue =
    let minValue = if minValue > 0 then minValue else RECOMMENDATION_LENGTH
    match maxValue with
    | Some max when max > RECOMMENDATION_LENGTH && minValue >= RECOMMENDATION_LENGTH ->
        let middle = (max + minValue) / 2
        if middle > 20 then 20 else middle
    | Some max when max > 0 && max <= RECOMMENDATION_LENGTH -> max
    | _ -> if minValue < RECOMMENDATION_LENGTH then RECOMMENDATION_LENGTH else minValue

let private tryFindEmptyIndex arr =
    let rec tryRandom ittr =
        if ittr > 5 then Array.findIndex ((=) EMPTY_SLOT) arr
        else 
            let rNum = rndGen.Next(arr.Length)
            if arr.[rNum] = EMPTY_SLOT then rNum
            else tryRandom (ittr + 1)

    if Array.isEmpty arr || (Array.exists ((=) EMPTY_SLOT) arr |> not) then None
    else tryRandom 0 |> Some

let private randomChar policy =
    if Array.isEmpty policy then ' ' else policy.[rndGen.Next(policy.Length)]

let private generateChars policy numberOfChars =
    if Array.isEmpty policy || numberOfChars < 1 then [||]
    else [| for x in 0 .. numberOfChars do yield randomChar policy |]

let newPassword (config: PasswordStrengthConfig) =
    let fillArray policy arr =
        if Array.length policy > 0 && Array.length arr > 0 then
            policy
            |> Array.iter
                (fun c ->
                    match tryFindEmptyIndex arr with
                    | Some idx -> arr.[idx] <- c
                    | None -> ()
                )
        else ()

    let fillEmptySlots = Array.map (fun x -> if x = EMPTY_SLOT then randomChar LOWER else x)

    let mutable passwordArr = Array.create (calcLength config.MinLength config.MaxLength) EMPTY_SLOT

    fillArray (generateChars SPECIAL config.MinSpecial) passwordArr
    fillArray (generateChars UPPER config.MinUpper) passwordArr
    fillArray (generateChars LOWER config.MinLower) passwordArr
    fillArray (generateChars NUMBERS config.MinNumeric) passwordArr
    fillArray (generateChars [| ' ' |] config.MinWhitespace) passwordArr

    passwordArr
    |> fillEmptySlots
    |> String